<template>
  <div class="wx-login tac" ref="dom">
    <div class="wx-login-inner" :id="id"></div>
  </div>
</template>

<script>
  import {appid, redirect_uri} from '@/config/config';
  import {mapMutations} from 'vuex';

  export default {
    name: "WxLogin",
    props: {
      to: {
        type: String,
        default: '',
      }
    },
    watch: {
      to() {
        this.createQr();
      },
    },
    data() {
      return {
        id: '',
      }
    },
    created() {
      this.id = this.Tools.rString(6, 'a');
    },
    mounted() {
      this.createQr();
    },
    methods: {
      ...mapMutations(['setQrState']),
      createQr() {
        let {id, to} = this;
        this.setQrState(id);
        if (/^\//.test(to)) {
          // to = location.href.replace(/#.*$/, '#' + to);
          if (process.env.NODE_ENV === 'development') {
            to = redirect_uri + 'wx_redirect.html?path=' + encodeURIComponent(location.href.replace(/#.*$/, '#' + to));
          } else {
            to = redirect_uri + '#' + to;
          }
        }
				console.log(to)
        to = encodeURIComponent(to);

        new WxLogin({
          self_redirect: false,
          id,
          appid,
          scope: 'snsapi_login,snsapi_userinfo',
          redirect_uri: to,
          // redirect_uri: encodeURIComponent(redirect_uri + to),
          state: id,
          style: '',
          href: ''
        })
      },
    }
  }
</script>

<style scoped>

</style>